import { render, staticRenderFns } from "./PresentationSection.vue?vue&type=template&id=569d9527&scoped=true&"
import script from "./PresentationSection.vue?vue&type=script&lang=js&"
export * from "./PresentationSection.vue?vue&type=script&lang=js&"
import style0 from "./PresentationSection.vue?vue&type=style&index=0&id=569d9527&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569d9527",
  null
  
)

export default component.exports